import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.loadCourse('data-science')
  }
  selectedCourse: string = '';
  courseContent: any = {};

  courseDetails = {
    'data-science': {
      title: '🎓 B.Sc. Data Science @ Sri Bala Sai Degree College – Unlock the Power of Data. Build the Future.',
      content: ` 🎓 B.Sc. Data Science – Course Overview & Career Potential<br><br>


<b> 📘 What is B.Sc. in Data Science? </b><br>
<i>B.Sc. Data Science</i> is a 3-year undergraduate degree program designed to equip students with the skills to extract meaningful insights from large datasets using modern tools, programming languages, and analytical techniques. It combines <i>Statistics, Computer Science, Mathematics, and <b>Domain Knowledge</b></i> to prepare students to solve real-world problems using data.<br><br>


<b> 🌟 Why Choose B.Sc. Data Science?</b><br>
🔍 Gain expertise in analyzing large datasets and discovering hidden patterns.<br>
💡 Master cutting-edge tools like <i>Python, R, SQL, Tableau, Power BI, and <b>Machine Learning</b></i>.<br>
🔐 Build a strong foundation in <i>AI, Data Mining, Big Data, Deep Learning, and <b>Cloud Technologies</b></i>.<br>
👨‍💻 Prepare for <i>high-paying, future-proof careers</i> in the digital economy.<br><br>


<b>🚀 Future Scope of B.Sc. Data Science</b><br>
* The <i>data economy is rapidly expanding</i> — by 2030, Data Science is projected to power over <b>11 million jobs in India alone</b>.<br>
* Every industry — from <i>healthcare and finance to e-commerce and agriculture</i> — depends on <i>data-driven decision-making</i>.<br>
* With the rise of <i>AI and automation</i>, data professionals are becoming the key decision-makers of the future.<br><br>


<b>📊 Market Demand & Relevance</b><br>
💼 <i>Massive industry demand</i>: Companies are in urgent need of skilled data scientists, yet there is a significant <b>talent gap</b>.<br>
📈 According to IBM, <i>90% of the world’s data has been generated in the last two years</i>, and organizations are actively seeking professionals to interpret it.<br>
🌎 Top global companies like <i>Google, Amazon, Flipkart, TCS, Infosys, Deloitte, Accenture, and <b>Microsoft</b></i> are hiring data science graduates.<br><br>



<b>💼 Job Opportunities After B.Sc. Data Science</b><br>
✅ Data Analyst<br>
✅ Data Scientist<br>
✅ Business Intelligence Analyst<br>
✅ Machine Learning Engineer<br>
✅ AI Engineer<br>
✅ Data Engineer<br>
✅ Statistician<br>
✅ Research Analyst<br>
✅ Big Data Analyst<br>
✅ Data Consultant<br><br>

<b>💰 Salary Expectations </b><br>
🧑‍🎓 <b>Freshers</b>: ₹4 LPA to ₹7 LPA<br>
👨‍💻 <b>With Experience</b>: ₹10 LPA to ₹25+ LPA<br>
🌍 <b>International Opportunities</b>: High demand in the <b>USA, UK, Canada, Germany, and <b>UAE</b></b><br><br>


<b>🏫 Why Choose B.Sc. Data Science at Our College?</b><br>
🖥 Industry-aligned curriculum with <i>hands-on labs and real-time projects</i><br>
📱 Smart learning through a <i>dedicated college app</i> and <i>e-learning platforms</i><br>
👨‍🏫 Experienced faculty with <i>real-world industry exposure</i><br>
🧠 <i>Campus Recruitment Training (CRT)</i> for job readiness<br>
🎯 <i>100% Placement Assistance</i> with internships and industry tie-ups<br>
📊 Regular <i>workshops, hackathons, and <b>guest lectures</b></i><br>
🧍‍♂ Personalized mentoring and student support system<br>
👮 A <i>safe and secure campus</i> with biometric attendance and <i>parental updates</i><br><br>


🎯 <b>Start your journey into the world of Big Data and AI – Enroll in B.Sc. Data Science Today!</b>`
    },

    'computer-science': {
      title: '💻 B.Sc. Computer Science @ Sri Bala Sai Degree College – Code the Future. Build Innovation.',
      content: `💻 B.Sc. Computer Science – Complete Overview & Future Scope<br><br>

<b>📘 What is B.Sc. Computer Science?</b><br>
* B.Sc. Computer Science is a 3-year undergraduate degree focused on the fundamentals and advanced concepts of computing, programming, algorithms, software development, databases, and computer systems.<br>
* Ideal for students passionate about technology, coding, and solving complex problems using computers.<br>
* Combines theoretical knowledge with practical exposure to prepare students for the fast-evolving IT world.<br><br>

<b>🌟 Why Choose B.Sc. Computer Science?</b><br>
✅ <b>Strong Foundation:</b> Covers key subjects such as programming languages, data structures, networking, operating systems, and database management.<br>
✅ <b>Skill Development:</b> Builds critical thinking, analytical skills, and problem-solving abilities essential for careers in technology.<br>
✅ <b>Hands-on Learning:</b> Includes practical labs, projects, and internships to provide real-world experience.<br>
✅ <b>Flexible Pathways:</b> Opens doors to advanced studies like M.Sc., MCA, or specialized professional certifications.<br><br>

<b>🚀 Future Scope & Market Demand</b><br>
* <b>Booming IT Industry:</b> The demand for skilled computer science graduates is rapidly increasing worldwide due to ongoing digital transformation.<br>
* <b>Wide Range of Fields:</b> Career opportunities span software development, cybersecurity, artificial intelligence, machine learning, data science, cloud computing, and more.<br>
* <b>Startups & Innovation:</b> Encourages entrepreneurial ventures in technology and innovation-driven industries.<br>
* <b>Government & Private Sector:</b> Strong demand exists in IT firms, banks, educational institutions, healthcare, and government organizations.<br>
* <b>Global Opportunities:</b> Graduates can work in multinational companies or pursue global certifications.
<br><br>

<b>💼 Job Opportunities After B.Sc. Computer Science</b><br>
✅ Software Developer/Engineer<br>
✅ Web Developer & Designer<br>
✅ Database Administrator<br>
✅ System Analyst<br>
✅ Network Administrator<br>
✅ Data Scientist & Analyst<br>
✅ Cybersecurity Expert<br>
✅ IT Support Engineer<br>
✅ Software Tester/QA Analyst<br>
✅ Cloud Computing Specialist<br><br>

<b>🎯 How B.Sc. CS Helps Students</b><br>
🧠 <b>Builds Problem-Solving Skills:</b> Equips students to approach challenges logically and efficiently.<br>
👨‍💻 <b>Enhances Programming Expertise:</b> Provides mastery in key programming languages like Python, Java, C++, and SQL.<br>
💼 <b>Prepares for Tech Careers:<b> Aligns curriculum with industry requirements for better employability.<br>
🚀 <b>Promotes Innovation:</b> Encourages creativity through projects and real-time coding challenges.<br>
🎓 <b>Boosts Higher Education Prospects:</b> Provides a strong foundation for M.Sc., MCA, or professional certifications.<br>
🌐 <b>Global Relevance:</b> The skills gained are in high demand worldwide, offering career flexibility.
<br><br>

<b>🏫 Why Enroll in B.Sc. Computer Science at Sri Bala Sai Degree College?</b><br>
🔹 Experienced faculty with industry exposure<br>
🔹 State-of-the-art computer labs and modern infrastructure<br>
🔹 Industry-aligned syllabus and curriculum<br>
🔹 Internships & placement assistance with leading IT companies<br>
🔹 Regular workshops, coding competitions, and skill development sessions<br>
🔹 Strong alumni network and mentorship programs<br><br>

🌐 <b>Take the First Step Toward a Bright Tech Career!</b>
Join <b>B.Sc. Computer Science</b> and unlock your potential in the world of technology. The future is digital — be the creator, innovator, and leader! `
    },

    'bca': {
      title: '💻 BCA @ Sri Bala Sai Degree College – Empowering Future IT Professionals',
      content: `💻 Bachelor of Computer Applications (BCA) – Complete Overview & Future Scope<br><br>

<b>📘 What is BCA?</b><br>
BCA is a 3-year undergraduate degree focused on computer applications, software development, and core IT fundamentals.<br>
Designed to equip students with strong technical knowledge and practical skills in programming, database management, networking, and software engineering.
<br>
Ideal for students passionate about technology and seeking a career in IT without pursuing an engineering degree.
<br><br>

<b>🌟 Why Choose BCA?</b><br>
✅ Offers an industry-relevant curriculum covering programming languages such as Java, Python, and C++, along with web development, data structures, and cloud computing.<br>
✅ Combines theoretical concepts with hands-on practical experience to build real-world skills.<br>
✅ Provides a solid foundation for careers in IT, software development, web design, and system management.<br>
✅ Opens avenues for higher education such as MCA, MBA (with IT specialization), and professional certifications in AI, Data Science, and Cybersecurity.<br><br>

<b>🚀 Future Scope & Market Demand</b><br>
📈 The global IT industry is expanding rapidly, with a sustained demand for skilled software professionals.
<br>
🤖 Advancements in digital transformation, artificial intelligence, big data, and cloud technologies are driving increased opportunities for BCA graduates.<br>
🏢 Startups, multinational corporations, and government organizations actively recruit BCA graduates for roles including software development, database administration, and network engineering.
<br>
💸 Starting salary packages typically range from 3 to 6 LPA, with potential for significant growth based on expertise and experience.<br><br>

<b>💼 Job Opportunities After BCA</b><br>
✅ Software Developer / Programmer<br>
✅ Web Developer / Designer<br>
✅ System Analyst / Network Administrator<br>
✅ Database Manager/ Administrator<br>
✅ Mobile Application Developer<br>
✅ IT Support & Technical Consultant<br>
✅ Cybersecurity Analyst<br>
✅ Digital Marketing and Data Analytics roles with appropriate certifications<br><br>


<b>How BCA Benefits Students from Various Streams (BiPC, CEC, MECs)</b><br>
* <b>BiPC (Biology, Physics, Chemistry):</b> Provides a technology-focused alternative, broadening career prospects beyond medical and biotechnology fields.<br>
* <b>CEC (Civics, Economics, Commerce):</b> Bridges the gap between commerce and IT, ideal for roles in IT-enabled services and digital business sectors.<br>
* <b>MECs (Maths, Economics, Commerce):</b> Combines mathematical aptitude with computer knowledge, making it well-suited for careers in data science, analytics, and software development.<br>
* BCA is a flexible and multidisciplinary degree, accessible and advantageous for students from non-engineering backgrounds.
<br><br>


🌟 <b>BCA vs. Engineering</b>
* For students who prefer not to pursue engineering, BCA serves as an excellent specialized professional degree focused on software and IT applications.<br>
* While engineering covers a broader spectrum of technology, including hardware and systems, BCA emphasizes in-depth software development and application skills.<br>
* Both paths offer robust career opportunities but cater to different interests and skill sets — BCA is more application- and programming-centric.<br>
* BCA graduates are highly employable within IT companies, often enjoying career prospects comparable to those of engineering graduates, especially in software-related roles.`
    },


    // 'math': {
    //   title: 'Interactive Learning in Mathematics',
    //   content: `UI-driven tools that aid learning abstract mathematical concepts.`,
    //   quote: 'Math is abstract — design gives it shape.'
    // }
  };

  loadCourse(courseKey: string) {
    this.selectedCourse = courseKey;
    this.courseContent = this.courseDetails[courseKey];
  }
}
